module.exports = __webpack_public_path__ + "701e0f3f47027e6b46fb0ab5f02ff96a.svg";